import type { CSSProperties } from 'react'

/**
 * CSS halftone: a grid of soft dots laid over a solid brand colour, the
 * flat-tile version of the InteractiveDots canvas. Decorative only.
 */
export function halftone(alpha = 0.32, pitch = 6): CSSProperties {
  return {
    backgroundImage: `radial-gradient(rgba(255,255,255,${alpha}) 0.9px, transparent 1.3px)`,
    backgroundSize: `${pitch}px ${pitch}px`,
  }
}

/** Brand colours the service kit cycles through for tiles and marks. */
export const BRAND = {
  blue: 'var(--color-landing-accent)',
  purple: 'var(--color-landing-secondary)',
  pink: '#ff00f2',
  green: '#00d722',
} as const

export type BrandColor = keyof typeof BRAND

/** The strong in-out curve for wipes that travel while visible (power4.inOut). */
export const WIPE_EASE = [0.76, 0, 0.24, 1] as const
/** The site's ease-out curve. */
export const OUT_EASE = [0.22, 1, 0.36, 1] as const
